/**
 * Lightweight UI sounds synthesized via Web Audio.
 * No asset files (the previous 2025 mp3s were horse-themed for the racing theme).
 *
 * Usage:
 *   import { playBot, playUser } from '../sounds';
 *   playBot();
 */

let ctx = null;
function getCtx() {
  if (typeof window === 'undefined') return null;
  if (!ctx) {
    const Ctor = window.AudioContext || window.webkitAudioContext;
    if (!Ctor) return null;
    ctx = new Ctor();
  }
  return ctx;
}

function tone({ freq = 660, duration = 0.16, type = 'sine', vol = 0.06, glide = null }) {
  try {
    const a = getCtx();
    if (!a) return;
    const t = a.currentTime;
    const osc = a.createOscillator();
    const gain = a.createGain();
    osc.type = type;
    osc.frequency.setValueAtTime(freq, t);
    if (glide) osc.frequency.exponentialRampToValueAtTime(glide, t + duration);
    gain.gain.setValueAtTime(0, t);
    gain.gain.linearRampToValueAtTime(vol, t + 0.01);
    gain.gain.exponentialRampToValueAtTime(0.0001, t + duration);
    osc.connect(gain).connect(a.destination);
    osc.start(t);
    osc.stop(t + duration + 0.05);
  } catch (e) {
    // silent failure — sound is non-essential
  }
}

/** Bot speaking — soft up-glide, muted */
export function playBot() {
  tone({ freq: 520, glide: 720, duration: 0.18, type: 'sine', vol: 0.05 });
}

/** User submit — quick down-glide, slightly brighter */
export function playUser() {
  tone({ freq: 880, glide: 660, duration: 0.10, type: 'triangle', vol: 0.05 });
}
